import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import LoadingScreen from './views/Loading.vue'
import Login from './views/Login.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'loading',
      component: LoadingScreen,
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      meta: {requireAuth: true}
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: "/repair",
      name: "repairListing",
      meta: {requireAuth: true},
      component: () => import(/* webpackChunkName: "repairListing" */ './pages/repairs/Listing.vue')
    }
  ],
});
router.beforeEach((to, from, next) => {
  store.dispatch('currentUser').then(result => {
    console.log(store.state.userState.isLoggingIn)
    // debugger
    if(store.state.userState.isLoggingIn && to.name !== "loading"){
      next({name: 'loading', params: {to: to.path }})
      return;
    }
    if(to.meta.requireAuth && !result){
      next('/login')
    }else{
      next()
    }
  }).catch(reason => {
    console.log(reason)
  })
});

export default router;